import { Utils } from "helpers/utils";
import { MemberRole, TaskStatus, tb_WpTagMasterCat, WorkPlaceTagUnreadSignalR, WpActionTypes, WpEmoji, WpFilterTaskDueMode, WpPostType, WpSliceData, WpStatus, WpTitle } from "./wpTypes";
import { Const, SKeys } from "const";
import { WpModes, WpSortMode } from "../../constants";

// same comparator "sort directly by DueDate" uses, reused below as ResponderName's tiebreaker on equal names
const compareDueDate = (a: WpTitle, b: WpTitle): number => {
  const aTime = a.planFinishedDate ? new Date(a.planFinishedDate).getTime() : null;
  const bTime = b.planFinishedDate ? new Date(b.planFinishedDate).getTime() : null;
  if (aTime == null && bTime == null) return 0;
  if (aTime == null) return 1;
  if (bTime == null) return -1;
  return aTime - bTime;
}

// mirrors the backend's RecentPost/DueDate/ResponderName ordering so switching sort mode on an already-loaded,
// dashboard-filtered task list doesn't require a backend round trip
const sortWpTitles = (titles: WpTitle[], sortMode: WpSortMode): WpTitle[] => {
  const arr = [...titles];
  if (sortMode === WpSortMode.DueDate) {
    arr.sort(compareDueDate);
  } else if (sortMode === WpSortMode.ResponderName) {
    arr.sort((a, b) => {
      const aName = a.responderName;
      const bName = b.responderName;
      if (!aName && !bName) return compareDueDate(a, b);
      if (!aName) return 1;
      if (!bName) return -1;
      const nameCompare = aName.localeCompare(bName);
      return nameCompare !== 0 ? nameCompare : compareDueDate(a, b);
    });
  } else {
    arr.sort((a, b) => new Date(b.lastChatDate).getTime() - new Date(a.lastChatDate).getTime());
  }
  return arr;
}

const initTagFilter = () => {
  try {
    const init_tag = localStorage.getItem(SKeys.EmbInitWpTag);
    if (!init_tag) return [];
    const data = JSON.parse(init_tag);
    localStorage.removeItem(SKeys.EmbInitWpTag);
    return data;
  } catch (e) {
    console.error(e);
  }
}

const initFilterNotClose = (wpMode: WpModes) => {
  try {
    const key = wpMode == WpModes.Workplace ? SKeys.InitWpFilterNoClose : SKeys.InitTkFilterNoClose;
    const init_filterNotClose = localStorage.getItem(key);
    if (!init_filterNotClose) return true;
    localStorage.removeItem(key);
    return false;
  } catch (e) {
    console.error(e);
    return true;
  }
}

const INIT_STATE: WpSliceData = {
  activePostInfo: {
    wpMode: null,
    postId: null,
    title: "",
    icon: "",
    abbrName: '➕',
    abbrFore: "#000000",
    abbrBack: "#C0C0C0",
    tags: [],
    flag: false,
    snooze: false,
    isYourPost: false,
    canDeletePost: false,
    canChangeStatus: false,
    youIsMember: true,
    status: WpStatus.Open,
    statusById: null,
    statusDate: null,
    statusRemark: null,
    statusByName: null,
    taskStatus: TaskStatus.ToDo,
  },
  activePostInfoLoading: false,
  postIdInstant: null,
  // activeTaskInfo: {
  //   postId: null,
  //   title: "",
  //   icon: "",
  //   abbrName: '➕',
  //   abbrFore: "#000000",
  //   abbrBack: "#C0C0C0",
  //   tags: [],
  //   flag: false,
  //   snooze: false,
  //   isYourPost: false,
  //   canDeletePost: false,
  //   canChangeStatus: false,
  //   youIsMember: true,
  //   status: WpStatus.Open,
  //   statusById: null,
  //   statusDate: null,
  //   statusRemark: null,
  //   statusByName: null,
  // },
  // activePostId: null,
  // activePostTitle: null,
  // activePostAbbr: '➕',
  // activePostAbbrFore: "#000000",
  // activePostAbbrBack: "#C0C0C0",
  // activePostTags: [],
  activeMemberRole: Utils.GetMemberRoleFromStorage(WpModes.Workplace),

  titleLoading: false,
  titleFromTaskDashboard: false,
  titleErrMsg: null,
  titles: [],
  titleLoadingMoreWp: false,
  titleHasMoreWp: true,
  lastTitleQueryWp: null,

  converLoading: false,
  converErrMsg: null,
  convers: [],
  converLoadingMore: false,
  converHasMore: true,
  roleUnread: {
    memberId: -1,
    reloadTitle: false,
    unreadOwner: 0,
    unreadFollower: 0,
    unreadTagMe: 0,
    unreadMyPost: 0,
    unreadFlag: 0,
    unreadOrganize: 0,
    unreadPersonFollow: 0,
    unreadObserver: 0,

    taskUnreadMine: 0,
    taskUnreadAssigner: 0,
    taskUnreadRequestBy: 0,
    taskUnreadFlag: 0,
    taskUnreadRelated: 0,
    taskUnreadObserver: 0,
  },
  tagFilterSelected: initTagFilter(),
  filterNotClose: initFilterNotClose(WpModes.Workplace),
  // filterTaskDueMode: WpFilterTaskDueMode.None,

  titlesTk: [],
  activeMemberRoleTk: Utils.GetMemberRoleFromStorage(WpModes.Task),
  tagFilterSelectedTk: initTagFilter(),
  taskStatusFilter: [],
  filterNotCloseTk: initFilterNotClose(WpModes.Task),
  titleLoadingMoreTk: false,
  titleHasMoreTk: true,
  lastTitleQueryTk: null,

  shareFilterWpTask: Utils.Conf_ShareFilterWpTask(),
  keywordWp: "",
  keywordTk: "",
  searchTriggerWp: 0,
  searchTriggerTk: 0,

  tagUnreadOnSignalR: [],
  taskDash: [],
  taskDashLoading: false,
  taskDashStatusLoading: false,
  taskDashTags: [],
  taskDashTagsLoading: false,
  taskDashFilterTagId: null,
  tagMasterCats: [],

  taskDashRecurance: [],
  taskDashRecuranceLoading: false,

  taskDashByDivRsp: [],
  taskDashByDivAsg: [],
  taskDashByDivReq: [],
  taskDashByDivLoading: false,
}

const apiErr = (state: WpSliceData, payload: any): WpSliceData => {
  // console.log('apiError:', payload);
  //if (payload.type == WpActionTypes.LOAD_POST_TITLE) {
  if (payload.type == WpActionTypes.LOAD_POST_TITLE_WP || payload.type == WpActionTypes.LOAD_POST_TITLE_TK) {
    return { ...state, titleLoading: false, titleErrMsg: payload.errMsg };
  }
  if (payload.type == WpActionTypes.LOAD_MORE_POST_TITLE_WP) {
    return { ...state, titleLoadingMoreWp: false };
  }
  if (payload.type == WpActionTypes.LOAD_MORE_POST_TITLE_TK) {
    return { ...state, titleLoadingMoreTk: false };
  }
  if (payload.type == WpActionTypes.LOAD_MORE_POST_CONVER) {
    return { ...state, converLoadingMore: false };
  }
  if (payload.type == WpActionTypes.SET_ACTIVE_POSTID2) {
    return { ...state, converLoading: false, converErrMsg: payload.errMsg || "โหลดข้อความไม่สำเร็จ" };
  }
  return { ...state };
}

const apiOk = (state: WpSliceData, payload: any): WpSliceData => {
  const type = payload.type as WpActionTypes;
  // console.log('apiOk:', payload);

  //if (type == WpActionTypes.LOAD_POST_TITLE) {
  if (type == WpActionTypes.LOAD_POST_TITLE_WP || type == WpActionTypes.LOAD_POST_TITLE_TK) {
    // console.log('Slice.WpActionTypes.LOAD_POST_TITLE:', payload.data);
    return {
      ...state,
      titleLoading: false,
      titleErrMsg: "",
      //titles: payload.data,
      titles: type == WpActionTypes.LOAD_POST_TITLE_WP ? payload.data.titles : state.titles,
      titlesTk: type == WpActionTypes.LOAD_POST_TITLE_TK ? payload.data.titles : state.titlesTk,
    };
  }

  if (type == WpActionTypes.LOAD_MORE_POST_TITLE_WP || type == WpActionTypes.LOAD_MORE_POST_TITLE_TK) {
    const moreTitles: WpTitle[] = payload.data.moreTitles ?? [];
    const hasMore = moreTitles.length >= 25;
    if (type == WpActionTypes.LOAD_MORE_POST_TITLE_WP) {
      const existingIds = new Set(state.titles.map(t => t.postId));
      return {
        ...state,
        titleLoadingMoreWp: false,
        titleHasMoreWp: hasMore,
        titles: [...state.titles, ...moreTitles.filter(t => !existingIds.has(t.postId))],
      };
    }
    const existingIdsTk = new Set(state.titlesTk.map(t => t.postId));
    return {
      ...state,
      titleLoadingMoreTk: false,
      titleHasMoreTk: hasMore,
      titlesTk: [...state.titlesTk, ...moreTitles.filter(t => !existingIdsTk.has(t.postId))],
    };
  }

  if (type == WpActionTypes.WP_TAG_MASTER_CAT_LOAD) {
    // console.log(payload.data.response);
    return {
      ...state,
      tagMasterCats: payload.data.response
    }
  }

  if (type == WpActionTypes.SET_ACTIVE_POSTID2) {
    return {
      ...state,
      converLoading: false,
      converErrMsg: "",
      convers: payload.data.convers,
      converHasMore: payload.data.converHasMore ?? state.converHasMore,
      createSubTaskFromTaskId: null,
    }
  }

  if (type == WpActionTypes.LOAD_MORE_POST_CONVER) {
    return {
      ...state,
      converLoadingMore: false,
      convers: [...(payload.data.moreConvers ?? []), ...state.convers],
      converHasMore: payload.data.converHasMore ?? false,
    }
  }

  if (type == WpActionTypes.LOAD_POST_INFO2) {
    //console.error('WpActionTypes.LOAD_POST_INFO2:', payload);
    return {
      ...state,
      activePostInfo: payload.data,
      activePostInfoLoading: false,
      // activePostTags: payload.data,
    }
  }

  if (type == WpActionTypes.GET_ROLE_UNREAD_COUNT) {
    return {
      ...state,
      roleUnread: payload.data
    }
  }

  if (type == WpActionTypes.LOAD_DLL_EMPLOYEE) {
    return {
      ...state,
      dllEmployee: payload.data
    }
  }

  if (type == WpActionTypes.WP_LOAD_TASK_DASH || type == WpActionTypes.WP_LOAD_TASK_DASHBOARD_BY_DIV) {
    // console.log("WpActionTypes.WP_LOAD_TASK_DASH:", payload.data.data ? payload.data.data : payload.data.byDiv);
    // console.log('payload.data.isLocal ? true : false = ' + (payload.data.isLocal));
    if (payload.data.data) {
      return {
        ...state,
        taskDash: payload.data.data,
        taskDashLoading: payload.data.isLocal ? true : false,
      }
    } else if (payload.data.byDiv) {
      return {
        ...state,
        taskDashByDivRsp: payload.data.divMode == "DIV_RSP" ? payload.data.byDiv : state.taskDashByDivRsp,
        taskDashByDivAsg: payload.data.divMode == "DIV_ASG" ? payload.data.byDiv : state.taskDashByDivAsg,
        taskDashByDivReq: payload.data.divMode == "DIV_REQ" ? payload.data.byDiv : state.taskDashByDivReq,
        taskDashByDivLoading: payload.data.isLocal ? true : false,
      }
    }
  }

  if (type == WpActionTypes.WP_LOAD_TASK_DASH_RECURANCE) {
    // console.log("WpActionTypes.WP_LOAD_TASK_DASH:", payload.data);
    // console.log('payload.data.isLocal ? true : false = ' + (payload.data.isLocal));
    return {
      ...state,
      taskDashRecurance: payload.data.data,
      taskDashRecuranceLoading: payload.data.isLocal ? true : false,
    }
  }

  if (type == WpActionTypes.WP_LOAD_TASK_DASH_TAGS) {
    return {
      ...state,
      taskDashTags: payload.data.data,
      taskDashTagsLoading: payload.data.isLocal ? true : false,
    }
  }


  if (type == WpActionTypes.WP_LOAD_TASK_DASH_STATUSRANGE) {
    // console.log('WpActionTypes.WP_LOAD_TASK_DASH_STATUSRANGE:', payload.data);
    return {
      ...state,
      taskDash: { ...state.taskDash, taskStatusRange: payload.data },
      taskDashStatusLoading: false
    }
  }

  if (type == WpActionTypes.WP_LOAD_SUB_TASK) {
    const parentTaskId = payload.data.parentTaskId;
    const titles = payload.data.response; // array

    // collect incoming postIds
    const incomingIds = new Set(titles.map((t: any) => t.postId));

    // remove duplicates from existing state
    const cleanedTitlesTk = state.titlesTk.filter(t => !incomingIds.has(t.postId));

    // find parent again (index may change after filtering)
    const index = cleanedTitlesTk.findIndex(x => x.postId === parentTaskId);

    if (index === -1) {
      return state;
    }

    const parent = cleanedTitlesTk[index];

    return {
      ...state,
      titlesTk: [
        ...cleanedTitlesTk.slice(0, index),
        {
          ...parent,
          isLoadingSub: false,
        },
        ...titles,                          // insert new list
        ...cleanedTitlesTk.slice(index + 1),
      ],
    };

  }


  return { ...state };
}

const WpSlice = (state: WpSliceData = INIT_STATE, action: any): WpSliceData => {
  // console.log(action);
  const type = action.type as WpActionTypes;
  if (type == WpActionTypes.API_ERR) return apiErr(state, action.payload);
  if (type == WpActionTypes.API_OK) return apiOk(state, action.payload);

  if (type == WpActionTypes.SORT_TITLES_TK_LOCAL) {
    return {
      ...state,
      titlesTk: sortWpTitles(state.titlesTk, action.payload.sortMode),
    }
  }

  if (type == WpActionTypes.WP_SET_TASK_DASH_FILTER_TAGID) {
    const { filterTagId } = action.payload;
    return {
      ...state,
      taskDashFilterTagId: filterTagId
    }
  }

  if (type == WpActionTypes.SET_ACTIVE_POSTID2) {
    // console.error('SET_ACTIVE_POSTID2:', action.payload);
    // console.log('action.payload.activePostInfo.postId ? true : false = ' + (action.payload.activePostInfo.postId ? true : false));
    return {
      ...state,
      activePostInfo: action.payload.activePostInfo,
      converLoading: action.payload.activePostInfo.postId ? true : false,
      converErrMsg: "",
      convers: [],
      converLoadingMore: false,
      converHasMore: true,
      createSubTaskFromTaskId: null,
    }
  }

  if (type == WpActionTypes.LOAD_MORE_POST_CONVER) {
    return {
      ...state,
      converLoadingMore: true,
    }
  }

  if (type == WpActionTypes.LOAD_POST_INFO2) {
    return {
      ...state,
      activePostInfoLoading: true,
    }
  }

  if (type == WpActionTypes.WP_SET_POSTID_FOR_INSTANCE) {
    return {
      ...state,
      postIdInstant: action.payload.postId,
    }
  }

  if (type == WpActionTypes.SET_CREATE_SUB_TASK) {
    return {
      ...state,
      createSubTaskFromTaskId: action.payload.createSubTaskFromTaskId
    }
  }

  if (type == WpActionTypes.WP_LOAD_TASK_DASH) {
    // console.log('WpActionTypes.WP_LOAD_TASK_DASH:');
    return {
      ...state,
      taskDashLoading: true,
    }
  }

  if (type == WpActionTypes.WP_LOAD_TASK_DASHBOARD_BY_DIV) {
    return {
      ...state,
      taskDashByDivLoading: true,
    }
  }

  if (type == WpActionTypes.WP_LOAD_TASK_DASH_RECURANCE) {
    // console.log('WpActionTypes.WP_LOAD_TASK_DASH:');
    return {
      ...state,
      taskDashRecuranceLoading: true,
    }
  }

  if (type == WpActionTypes.WP_LOAD_TASK_DASH_TAGS) {
    // console.log('WpActionTypes.WP_LOAD_TASK_DASH:');
    return {
      ...state,
      taskDashTagsLoading: true,
    }
  }



  if (type == WpActionTypes.WP_LOAD_TASK_DASH_STATUSRANGE) {
    return {
      ...state,
      taskDashStatusLoading: true
    }
  }

  if (type == WpActionTypes.WP_LOAD_SUB_TASK) {
    const { parentTaskId } = action.payload;
    return {
      ...state,
      titlesTk: state.titlesTk.map(x => x.postId === parentTaskId ? ({ ...x, isLoadingSub: true }) : x),
    }
  }

  if (type == WpActionTypes.SET_DRAFT_POST) {

    const { wpMode, postId, draft } = action.payload;
    // console.log('WpActionTypes.SET_DRAFT_POST:', action.payload);
    // check if postId exists
    const exists = (wpMode == WpModes.Workplace ? state.titles : state.titlesTk).some(e => e.postId === postId);
    if (!exists) return state; // no changes → return same state object

    return {
      ...state,
      //titles: state.titles.map(e => e.postId === postId ? ({ ...e, draft: draft }) : ({ ...e }))
      ...(wpMode == WpModes.Workplace
        ? { titles: state.titles.map(e => e.postId === postId ? ({ ...e, draft: draft }) : ({ ...e })) }
        : { titlesTk: state.titlesTk.map(e => e.postId === postId ? ({ ...e, draft: draft }) : ({ ...e })) })
    }
  }

  if (type == WpActionTypes.SET_POST_INFO_ONLY) {
    const { postInfo } = action.payload;
    const updateTitle = (x: any, postInfo: any) =>
      x.postId === postInfo.postId
        ? {
          ...x,
          title: postInfo.title,
          abbrName: postInfo.abbrName,
          abbrFore: postInfo.abbrFore,
          abbrBack: postInfo.abbrBack,
          status: postInfo.status,
          taskStatus: postInfo.taskStatus,
          planFinishedDate: postInfo.planFinishedDate,
          isTaskOverdue: postInfo.isTaskOverdue,
          isSubTask: postInfo.isSubTask,
          subTaskCount: postInfo.subTaskCount,
          parentTaskId: postInfo.parentTaskId,
          actFinishedDate: postInfo.actFinishedDate,
          approveStatus: postInfo.approveStatus,
        }
        : x;

    const baseState = {
      ...state,
      activePostInfo: state.activePostInfo?.postId === postInfo.postId ? postInfo : state.activePostInfo,
    };

    // 20260828 keep the SAME array reference when the post isn't in the list at all.
    // .map() always builds a new array, and WorkplaceTitle.tsx watches [titles]/[titlesTk] to decide
    // whether to clear activePostId ("post no longer in the list"). Posts opened from outside the list
    // (sub-task popup, Approval Center, redirect) are never in it, so a plain .map() here fired that
    // effect and wiped the post the user had just opened - see clearActivePostOnTitleChange.
    const updateTitleList = (list: WpTitle[]) => {
      const found = list.some(x => x.postId === postInfo.postId);
      return found ? list.map(x => updateTitle(x, postInfo)) : list;
    };

    if (postInfo.wpMode === WpModes.Workplace) {
      return {
        ...baseState,
        titles: updateTitleList(state.titles),
      };
    }

    return {
      ...baseState,
      titlesTk: updateTitleList(state.titlesTk),
    };
  }

  if (type == WpActionTypes.SET_POST_INFO_ON_SIGNALR) {
    const { postInfo, lastChatText, lastChatTime, lastChatImg, unreadCount, memberRoles } = action.payload;
    // console.log('SetPostInfoSlice:', { postInfo, lastChatText, lastChatTime, lastChatImg, unreadCount, memberRoles });
    const isWp = postInfo.wpMode == WpModes.Workplace;
    const activeRole1 = isWp ? state.activeMemberRole : state.activeMemberRoleTk;
    const activeRole2 = isWp ? (activeRole1 == MemberRole.Organize ? MemberRole.PersonFollow : -1) : -1;
    const allRole = activeRole1 == MemberRole.All;
    //const onView = allRole || memberRoles.find((t: any) => (t == activeRole1 || t == activeRole2));
    const onView = memberRoles.find((t: any) =>
      (t == activeRole1 || t == activeRole2)
      || (allRole && t !== MemberRole.Observer)
    );

    // console.log('check post display:', { onView, memberRoles, activeRole1, activeRole2, allRole });
    if (!onView) {
      // console.log('new message not on selected role');
      return { ...state };
    }

    const index =
      isWp
        ? state.titles.findIndex(t => t.postId === postInfo.postId)
        : state.titlesTk.findIndex(t => t.postId === postInfo.postId);
    // console.log('index = ' + index);
    let newTitles = isWp ? [...state.titles] : [...state.titlesTk];
    if (index !== -1) { // found existing
      // const existing = {
      //   ...newTitles[index],
      //   title: postInfo.title,
      //   lastChatText: lastChatText,
      //   lastChatImg: lastChatImg,
      //   lastChatDate: lastChatTime,
      //   abbrName: postInfo.abbrName,
      //   abbrFore: postInfo.abbrFore,
      //   abbrBack: postInfo.abbrBack,
      //   status: postInfo.status,
      //   unread: unreadCount,
      //   taskStatus: postInfo.taskStatus,
      //   planFinishedDate: postInfo.planFinishedDate,
      //   isTaskOverdue: postInfo.isTaskOverdue,
      //   isSubTask: postInfo.isSubTask,
      //   subTaskCount: postInfo.subTaskCount,
      //   parentTaskId: postInfo.parentTaskId,
      // };
      // newTitles.splice(index, 1);
      // newTitles.unshift(existing);
      const oldItem = newTitles[index];
      const updatedItem = {
        ...oldItem,
        title: postInfo.title,
        lastChatText,
        lastChatImg,
        lastChatDate: lastChatTime,
        abbrName: postInfo.abbrName,
        abbrFore: postInfo.abbrFore,
        abbrBack: postInfo.abbrBack,
        status: postInfo.status,
        unread: unreadCount,
        taskStatus: postInfo.taskStatus,
        planFinishedDate: postInfo.planFinishedDate,
        isTaskOverdue: postInfo.isTaskOverdue,
        isSubTask: postInfo.isSubTask,
        subTaskCount: postInfo.subTaskCount,
        parentTaskId: oldItem.parentTaskId,
        actFinishedDate: postInfo.actFinishedDate,
        approveStatus: postInfo.approveStatus,
      };

      // ✅ if it is a sub-task → update only
      if (oldItem.parentTaskId) {
        newTitles[index] = updatedItem;
      } else {
        // ✅ top-level task → move to top
        newTitles.splice(index, 1);
        newTitles.unshift(updatedItem);
      }
    } else { // not found
      newTitles.unshift({
        ...postInfo,
        title: postInfo.title,
        lastChatImg: lastChatImg,
        lastChatDate: lastChatTime,
        abbrName: postInfo.abbrName,
        abbrFore: postInfo.abbrFore,
        abbrBack: postInfo.abbrBack,
        status: postInfo.status,
        unread: unreadCount,
        taskStatus: postInfo.taskStatus,
        planFinishedDate: postInfo.planFinishedDate,
        isTaskOverdue: postInfo.isTaskOverdue,
        isSubTask: postInfo.isSubTask,
        subTaskCount: postInfo.subTaskCount,
        parentTaskId: postInfo.parentTaskId,
        actFinishedDate: postInfo.actFinishedDate,
      });
    }

    // console.log('wpSliteSetPostOnSignalR:', { state: state.activePostInfo, new: postInfo });

    return {
      ...state,
      activePostInfo: state.activePostInfo.postId === postInfo.postId ? postInfo : state.activePostInfo,
      ...(isWp ? { titles: newTitles } : { titlesTk: newTitles })
      //   titles: isWp ? newTitles : state.titles,
      //   titlesTk: isWp ? state.titlesTk : newTitles
    };
  }

  if (type == WpActionTypes.UPDATE_POST_UNREAD_COUNT) {
    const { wpMode, postId, memberId, unreadCount } = action.payload;
    // console.log('UPDATE_POST_UNREAD_COUNT:', action.payload);
    if (wpMode == WpModes.Workplace) {
      return {
        ...state,
        titles: state.titles.map((title) => title.postId === postId ? { ...title, unread: unreadCount } : title),
        convers: (state.convers ?? []).map((c) => c.postIdParent == postId ? { ...c, isRead: true } : c),
      }
    } else {
      return {
        ...state,
        titlesTk: state.titlesTk.map((title) => title.postId === postId ? { ...title, unread: unreadCount } : title),
        convers: (state.convers ?? []).map((c) => c.postIdParent == postId ? { ...c, isRead: true } : c),
      }
    }
  }

  //if (type == WpActionTypes.LOAD_POST_TITLE) {
  if (type == WpActionTypes.LOAD_POST_TITLE_WP || type == WpActionTypes.LOAD_POST_TITLE_TK) {
    const isWp = type == WpActionTypes.LOAD_POST_TITLE_WP;
    return {
      ...state,
      titleLoading: true,
      titleFromTaskDashboard: action.payload.callFrom === Const.LOAD_POST_TITLE_CALLING_FROM_DASH,
      // 20260907 stash this search's filters so a later scroll-triggered "load more" can replay them
      // (plus a cursor) without every search call site having to build/pass that payload twice.
      ...(isWp
        ? { lastTitleQueryWp: action.payload, titleHasMoreWp: true }
        : { lastTitleQueryTk: action.payload, titleHasMoreTk: true })
    }
  }

  if (type == WpActionTypes.LOAD_MORE_POST_TITLE_WP) {
    return { ...state, titleLoadingMoreWp: true };
  }

  if (type == WpActionTypes.LOAD_MORE_POST_TITLE_TK) {
    return { ...state, titleLoadingMoreTk: true };
  }

  if (type == WpActionTypes.APPEND_POST_CONVER) {
    // console.log('APPEND_POST_CONVER:', action);
    const conv2add = action.payload.postData;

    if (conv2add == null || conv2add.length <= 0) return { ...state };
    if (conv2add[0].postIdParent != state.activePostInfo.postId) return { ...state };

    // A post may reach the client via more than one SignalR event (e.g. a DSign log post to a user
    // who is both a real task member and a flow approver) - dedupe by postId so it's never appended twice.
    const existingIds = new Set(state.convers.map((c: any) => c.postId));
    const newConvs = conv2add.filter((c: any) => !existingIds.has(c.postId));
    if (newConvs.length <= 0) return { ...state };

    return {
      ...state,
      convers: [...state.convers, ...newConvs]
    }
    // console.log('existing state:', state.activePostInfo.postId);
    // return {
    //   ...state,
    //   convers: [...state.convers, ...action.payload.postData]
    // }
    // return {
    //   ...state,
    //   convers: [
    //     ...state.convers,
    //     ...action.payload.postData.filter(
    //       (post: any) => post.postIdParent === state.activePostInfo.postId
    //     )
    //   ]
    // };
  }

  if (type == WpActionTypes.SET_ACTIVE_MEMBERROLE) {
    Utils.SetMemberRoleToStorage(action.payload.wpMode, action.payload.memberRole);
    if (action.payload.wpMode == WpModes.Workplace)
      return { ...state, activeMemberRole: action.payload.memberRole }
    else if (action.payload.wpMode == WpModes.Task)
      return { ...state, activeMemberRoleTk: action.payload.memberRole }
  }

  if (type == WpActionTypes.SET_FILTER_SELECTED) {
    const { wpMode, tagSelected, filterNotClose } = action.payload;
    // console.log(action.payload);
    if (wpMode == WpModes.Workplace) {
      return {
        ...state,
        //tagFilterSelected: action.payload.tagSelected,
        tagFilterSelected: tagSelected === undefined ? state.tagFilterSelected : tagSelected,
        filterNotClose: filterNotClose === undefined ? state.filterNotClose : filterNotClose,
        tagFilterSelectedTk: (state.shareFilterWpTask && tagSelected !== undefined) ? tagSelected : state.tagFilterSelectedTk
      }
    } else if (wpMode == WpModes.Task) {
      return {
        ...state,
        //tagFilterSelected: action.payload.tagSelected,
        tagFilterSelectedTk: tagSelected === undefined ? state.tagFilterSelectedTk : tagSelected,
        filterNotCloseTk: filterNotClose === undefined ? state.filterNotCloseTk : filterNotClose,
        tagFilterSelected: (state.shareFilterWpTask && tagSelected !== undefined) ? tagSelected : state.tagFilterSelected
      }
    } else {
      return { ...state }
    }
  }

  if (type == WpActionTypes.SET_SHARE_FILTER_WP_TASK) {
    const { shareFilterWpTask } = action.payload;
    return { ...state, shareFilterWpTask }
  }

  if (type == WpActionTypes.SET_KEYWORD) {
    const { wpMode, keyword, searchNow } = action.payload;
    if (state.shareFilterWpTask) {
      // 20260724 when an actual search (not just typing) is performed, bump the OTHER mode's
      // search trigger counter so it reloads its list in the background (see Workplace/index.tsx).
      const searchTriggerBump = !searchNow ? {} : wpMode == WpModes.Workplace
        ? { searchTriggerTk: state.searchTriggerTk + 1 }
        : { searchTriggerWp: state.searchTriggerWp + 1 };
      return { ...state, keywordWp: keyword, keywordTk: keyword, ...searchTriggerBump }
    }
    return wpMode == WpModes.Workplace ? { ...state, keywordWp: keyword } : { ...state, keywordTk: keyword }
  }

  // if (type == WpActionTypes.SET_FILTER_TASK_DUEMODE) {
  //   const { mode } = action.payload;
  //   return { ...state, filterTaskDueMode: mode === state.filterTaskDueMode ? WpFilterTaskDueMode.None : mode }
  // }

  if (type == WpActionTypes.SET_TASK_STATUS_FILTER) {
    const { taskStatus } = action.payload;
    return {
      ...state,
      taskStatusFilter:
        state.taskStatusFilter.some(x => x == taskStatus)
          ? state.taskStatusFilter.filter(x => x != taskStatus)
          : [...state.taskStatusFilter, taskStatus]
    }
  }

  if (type == WpActionTypes.CLEAR_ALL_FILTER) {
    const { wpMode } = action.payload;
    const isTaskMode = wpMode === WpModes.Task;
    if (state.shareFilterWpTask) {
      return {
        ...state,
        taskStatusFilter: isTaskMode ? [] : state.taskStatusFilter,
        tagFilterSelected: [],
        tagFilterSelectedTk: [],
      }
    }
    return {
      ...state,
      taskStatusFilter: isTaskMode ? [] : state.taskStatusFilter,
      tagFilterSelected: isTaskMode ? state.tagFilterSelected : [],
      tagFilterSelectedTk: isTaskMode ? [] : state.tagFilterSelectedTk,
    }
  }

  if (type == WpActionTypes.REMOVE_POST_TITLE_FROM_LIST) {
    const { postId } = action.payload;
    return {
      ...state,
      titles: state.titles.filter(t => t.postId !== postId)
    }

  }

  if (type == WpActionTypes.SET_FLAG) {
    const { wpMode, postId, flag } = action.payload;
    const isWp = wpMode == WpModes.Workplace;
    return {
      ...state,
      activePostInfo: {
        ...state.activePostInfo,
        flag: state.activePostInfo.postId === postId ? flag : state.activePostInfo.flag
      },
      //titles: state.titles.map(e => e.postId === postId ? { ...e, flag: flag } : { ...e })
      ...(isWp
        ? { titles: state.titles.map(e => e.postId === postId ? { ...e, flag: flag } : { ...e }) }
        : { titlesTk: state.titlesTk.map(e => e.postId === postId ? { ...e, flag: flag } : { ...e }) }
      )
    };
  }

  if (type == WpActionTypes.SET_POST_ICON) {
    const { wpMode, postId, icon } = action.payload;
    const isWp = wpMode == WpModes.Workplace;
    return {
      ...state,
      activePostInfo: {
        ...state.activePostInfo,
        icon: state.activePostInfo.postId === postId ? icon : state.activePostInfo.icon
      },
      ...(isWp
        ? { titles: state.titles.map(e => e.postId === postId ? { ...e, icon: icon } : { ...e }) }
        : { titlesTk: state.titlesTk.map(e => e.postId === postId ? { ...e, icon: icon } : { ...e }) }
      )
    };
  }

  if (type == WpActionTypes.SET_SNOOZE) {
    const { wpMode, postId, snooze } = action.payload;
    const isWp = wpMode == WpModes.Workplace;
    // console.log('WpActionTypes.SET_SNOOZE:', { postId, snooze });
    return {
      ...state,
      activePostInfo: {
        ...state.activePostInfo,
        snooze: state.activePostInfo.postId === postId ? snooze : state.activePostInfo.snooze
      },
      //titles: state.titles.map(e => e.postId === postId ? { ...e, snooze: snooze } : { ...e })
      ...(isWp
        ? { titles: state.titles.map(e => e.postId === postId ? { ...e, snooze: snooze } : { ...e }) }
        : { titlesTk: state.titlesTk.map(e => e.postId === postId ? { ...e, snooze: snooze } : { ...e }) })
    };
  }

  if (type == WpActionTypes.SET_UNREAD) {
    const { wpMode, postId, unread } = action.payload;
    const isWp = wpMode == WpModes.Workplace;
    // console.log('WpActionTypes.SET_SNOOZE:', { postId, snooze });
    return {
      ...state,
      //titles: state.titles.map(e => e.postId === postId ? { ...e, unread: unread } : { ...e })
      ...(isWp
        ? { titles: state.titles.map(e => e.postId === postId ? { ...e, unread: unread } : { ...e }) }
        : { titlesTk: state.titlesTk.map(e => e.postId === postId ? { ...e, unread: unread } : { ...e }) })
    };
  }

  if (type == WpActionTypes.MARK_AS_READ) {
    const { wpMode, postIds } = action.payload;
    const idSet = new Set(postIds.split('|'));
    const isWp = wpMode == WpModes.Workplace;
    return {
      ...state,
      ...(isWp
        ? { titles: state.titles.map(e => idSet.has(e.postId) ? { ...e, unread: 0 } : e) }
        : { titlesTk: state.titlesTk.map(e => idSet.has(e.postId) ? { ...e, unread: 0 } : e) })
    };
  }

  if (type == WpActionTypes.TOGGLE_POST_EMOJI) {
    const { postIdParent, postId, emojiName, emojiIcon, isAdd, memberName } = action.payload;
    if (postIdParent !== state.activePostInfo?.postId) return { ...state }
    // console.log('Reducer TOGGLE_POST_EMOJI:', { postIdParent, postId, emojiName, emojiIcon, isAdd, memberName });
    return {
      ...state,
      convers: state.convers.map(con => {
        if (con.postId !== postId) return con;

        const emojis = con.emojis ?? [];
        const emojiIndex = emojis.findIndex(t => t.nm === emojiName);
        // console.log('emojiIndex = ' + emojiIndex);

        let updatedEmojis: WpEmoji[];
        // console.log('updatedEmojis prev:', emojis);

        if (emojiIndex === -1 && isAdd) {
          // Not found and need to add
          updatedEmojis = [...emojis, { nm: emojiName, ji: emojiIcon, mbr: memberName }];
        } else if (emojiIndex !== -1) {
          const emoji = emojis[emojiIndex];
          const members = emoji.mbr.split("|");

          const newMembers = isAdd
            ? Array.from(new Set([...members, memberName]))
            : members.filter(x => x !== memberName);

          // console.log('newMembers:', newMembers);

          // Update emoji immutably
          const updatedEmoji = { ...emoji, mbr: newMembers.join("|") };

          // Update emojis array immutably
          updatedEmojis = emojis.map((e, i) => (i === emojiIndex ? updatedEmoji : e));
        } else {
          updatedEmojis = emojis;
        }
        // console.log('updatedEmojis after:', updatedEmojis);
        return { ...con, emojis: updatedEmojis };
      })
    };
  }

  if (type == WpActionTypes.MARK_POST_UNSEND) {
    const { wpMode, postIdParent, postId, isDelPost } = action.payload;
    const isWp = wpMode == WpModes.Workplace;
    // console.log('Reducer.MARK_POST_UNSEND:', { postIdParent, postId, isDelPost });
    if (isDelPost) {
      return {
        ...state,
        //titles: state.titles.filter(x => x.postId !== postIdParent)
        ...(isWp
          ? { titles: state.titles.filter(x => x.postId !== postIdParent) }
          : { titlesTk: state.titlesTk.filter(x => x.postId !== postIdParent) })
      }
    } else {
      if (postIdParent !== state.activePostInfo?.postId) return { ...state }
      return {
        ...state,
        convers: state.convers.map(con => con.postId === postId ? { ...con, isUnsend: true } : con)
      }
    }
  }

  if (type === WpActionTypes.CHANGE_POST_STATUS) {
    const { wpMode, postIdParent, status } = action.payload;
    const isWp = wpMode == WpModes.Workplace;
    return {
      ...state,
      //titles: state.titles.map(e1 => e1.postId === postIdParent ? { ...e1, status: status } : e1)
      ...(isWp
        ? { titles: state.titles.map(e1 => e1.postId === postIdParent ? { ...e1, status: status } : e1) }
        : { titlesTk: state.titlesTk.map(e1 => e1.postId === postIdParent ? { ...e1, status: status } : e1) })
    }
  }

  if (type === WpActionTypes.SET_IS_EMB_CHAT_ONLY) {
    return {
      ...state,
      isEmbChatOnly: action.payload.isEmbChatOnly
    }
  }

  if (type === WpActionTypes.TAG_UNREAD_ON_SIGNALR) {
    const incoming = action.payload.tagUnread as WorkPlaceTagUnreadSignalR[];
    // console.log('incoming:', incoming);
    if (incoming.length <= 0 || (incoming.length == 1 && incoming[0].unreadCount === Const.TAG_UNREAD_NO_PENDING)) { // no pending unread
      return {
        ...state,
        tagUnreadOnSignalR: state.tagUnreadOnSignalR.map(x => ({ ...x, unreadCount: 0 }))
      };
    }

    if (incoming.length === 1 && incoming[0].tagId === -1) { // read-all sentinel: zero out all tags for this memberId + wpMode
      const { memberId, wpMode } = incoming[0];
      return {
        ...state,
        tagUnreadOnSignalR: state.tagUnreadOnSignalR.map(x =>
          x.memberId === memberId && x.wpMode === wpMode ? { ...x, unreadCount: 0 } : x
        )
      };
    }

    return { /* use this version because change signalr send only tag have unread, no unread not send */
      ...state,
      tagUnreadOnSignalR: incoming
    };
    /*
    const updated = [...state.tagUnreadOnSignalR];

    incoming.forEach(item => {
      const index = updated.findIndex(x =>
        x.wpMode === item.wpMode &&
        x.memberId === item.memberId &&
        x.tagId === item.tagId
      );

      if (index >= 0) {
        // update existing
        updated[index] = {
          ...updated[index],
          unreadCount: item.unreadCount
        };
      } else {
        // add new
        updated.push(item);
      }
    });

    return {
      ...state,
      tagUnreadOnSignalR: updated
    };
    */
  }

  // default
  return { ...state }
}

export default WpSlice;